module.exports = __webpack_public_path__ + "static/media/carousal_3.da96bb53.png";